<template>
  <div class="a7-visao-evolucao-chart">
    <gw-cartesian-chart :labels="labels" :width="400" :height="180" class="chart">
      <component
        :is="dataset"
        v-for="(medida, index) in medidas"
        :key="index"
        :label="medida.datasetLabel || medida.medida"
        :data="getData(medida)"/>
      <gw-scales>
        <gw-y-axis :formatter="formatter"/>
      </gw-scales>
    </gw-cartesian-chart>
    <div class="buttons">
      <gw-button
        v-for="tipo in tipos"
        :key="tipo"
        @click="tipoAgrupamento = tipo"
        :class="{default: tipoAgrupamento === tipo}">
        {{ $t('VisaoEvolucao.tipo.' + tipo) }}
      </gw-button>
    </div>
  </div>
</template>

<script>
import {
  GwCartesianChart,
  GwBarDataset,
  GwLineDataset,
  GwScales,
  GwYAxis,
  GwButton,
  Formatters,
  FilterUtilities
} from 'guaxinim-web';
import VisaoRestResource from '../visao/VisaoRestResource';
import A7PainelAnaliseFormatacao from '../painel-analise/A7PainelAnaliseFormatacao';

export default {
  name: 'a7-visao-evolucao-chart',
  components: {
    GwCartesianChart,
    GwBarDataset,
    GwLineDataset,
    GwScales,
    GwYAxis,
    GwButton
  },
  props: {
    filterParams: {
      type: Object,
      required: true
    },
    medidas: {
      type: Array,
      require: true
    },
    tipo: {
      type: String,
      default: 'barra',
      validator: (valor) => ['barra', 'linha'].indexOf(valor) !== -1
    }
  },
  data() {
    return {
      tipoAgrupamento: 'A',
      labels: [],
      valores: [],
      formato: null,
      tipos: ['A', 'B', 'C', 'D', 'E']
    }
  },
  computed: {
    dataset() {
      switch (this.tipo) {
        case 'barra':
          return 'gw-bar-dataset';
        case 'linha':
          return 'gw-line-dataset';
      }
    }
  },
  watch: {
    tipoAgrupamento() {
      this.refreshData();
    },
    filterParams: {
      deep: true,
      immediate: true,
      handler() {
        this.refreshData();
      }
    }
  },
  methods: {
    refreshData() {

      const visoes = this.medidas.map(medida => medida.visao);
      const medidas = this.medidas.map(medida => medida.medida);
      const tipoMedidas = this.medidas.map(medida => medida.tipoMedida);
      const filterParamsString = FilterUtilities.createFilterParamsString(this.filterParams);

      this.heavyTask(
        VisaoRestResource.findVisaoEvolucaoDTO(
            this.tipoAgrupamento, visoes, medidas, tipoMedidas, filterParamsString)
          .then(dto => {
            this.labels = dto.periodo;
            this.valores = dto.itens;
            this.formato = dto.formato;
          })
          .catch(err => this.$gw.defaultExceptionHandler.handleUnknownException(err, this)));
    },
    getData(medida) {
      const data = this.valores.find(
        itemDTO => itemDTO.visao === medida.visao && itemDTO.medida === medida.medida);
      if (data) {
        return data.valores;
      }
      return data || [];
    },
    formatter(valor) {
      return A7PainelAnaliseFormatacao.formataValor(valor, this.formato);
    }
  }
}
</script>

<style lang="scss" scoped>
.a7-visao-evolucao-chart {
  position: relative;

  .gw-cartesian-chart {
    margin: 0 5px;
  }

  .buttons {
    display: flex;
    flex-wrap: wrap;
    margin: 3px;

    .gw-button {
      flex-grow: 1;
      flex-basis: 0;
      margin: 3px;
    }
  }
}
</style>

